export const Fields = [
  {
    name: 'name',
    placeholder: 'Admin Name',
    label: 'Admin Name',
  },
  {
    name: 'position',
    placeholder: 'Position',
    label: 'Position',
  },
  {
    name: 'email',
    placeholder: 'Email',
    label: 'Email',
  },
  {
    name: 'phone',
    placeholder: 'Phone Number (optional)',
    label: 'Phone Number (optional)',
    addonbefore: '+1',
  },
  {
    name: 'createPassword',
    placeholder: 'Create Password',
    label: 'Create Password',
    password: true,
    visibilityToggle: true,
  },
  {
    name: 'confirmPassword',
    placeholder: 'Confirm Password',
    label: 'Confirm Password',
    password: true,
    visibilityToggle: true,
  },
];

export const initialValues = {
  name: '',
  position: '',
  email: '',
  phone: '',
  createPassword: '',
  confirmPassword: '',
  terms: false,
};
